import { render } from "./iconReports.vue?vue&type=template&id=058eb046"
import script from "./iconReports.vue?vue&type=script&lang=js"
export * from "./iconReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__